export default class WindowEnv {
  static defaultHost() {
    return window.ENV.defaultHost;
  }

  static isChoicesEnabled() {
    return window.ENV.settings.choices_enabled;
  }

  static isWithinPodcastApp() {
    return window.ENV.settings.within_podcast_app;
  }
}
